"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ticketApprovalSnapshotSchema = exports.ticketApprovalLatestActionSchema = exports.approvalSupersedeReasonSchema = exports.APPROVAL_SUPERSEDE_REASONS = exports.ticketApprovalSnapshotStatusSchema = exports.TICKET_APPROVAL_SNAPSHOT_STATUSES = void 0;
const zod_1 = require("zod");
const approval_inbox_1 = require("./approval-inbox");
const approval_rules_1 = require("./approval-rules");
exports.TICKET_APPROVAL_SNAPSHOT_STATUSES = [
    'pending',
    'changes_requested',
    'approved',
    'rejected',
    'superseded',
];
exports.ticketApprovalSnapshotStatusSchema = zod_1.z.enum(exports.TICKET_APPROVAL_SNAPSHOT_STATUSES);
// Entity-agnostic: approval_requests carries supersede reasons for every host type.
exports.APPROVAL_SUPERSEDE_REASONS = ['different_rule', 'no_match', 'entity_deleted'];
exports.approvalSupersedeReasonSchema = zod_1.z.enum(exports.APPROVAL_SUPERSEDE_REASONS);
exports.ticketApprovalLatestActionSchema = zod_1.z.object({
    action_type: approval_inbox_1.approvalInboxActionTypeSchema,
    role: approval_rules_1.pgApproverRoleSchema,
    comment: zod_1.z.string().nullable(),
    actor_email: zod_1.z.string().nullable(),
    taken_at: zod_1.z.string(),
    cycle: zod_1.z.number().int().min(1),
});
exports.ticketApprovalSnapshotSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    rule_id: zod_1.z.string().uuid().nullable(),
    rule_label: zod_1.z.string(),
    required_approvers: zod_1.z.array(approval_rules_1.pgApproverRoleSchema),
    mode: approval_rules_1.approvalModeSchema,
    approval_status: exports.ticketApprovalSnapshotStatusSchema,
    superseded_reason: exports.approvalSupersedeReasonSchema.nullable(),
    requested_by_user_id: zod_1.z.string().nullable(),
    created_at: zod_1.z.string(),
    latest_action: exports.ticketApprovalLatestActionSchema.nullable(),
});
//# sourceMappingURL=ticket-approval.js.map